// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}
.input-wrapper i {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 10;
}
.loader.hidden {
  opacity: 0;
  pointer-events: none;
  /* Prevent interaction with hidden loader */
}
/*# sourceMappingURL=bookings-form.component.css.map */`, "",{"version":3,"sources":["webpack://./bookings-form.component.less","webpack://./src/app/bookings/bookings-form/bookings-form.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;ACDF;ADAA;EAII,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;ACDJ;ADKA;EACE,UAAA;EACA,oBAAA;ECHA,2CAA2C;AAC7C;AACA,sDAAsD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.input-wrapper {\n  position: relative;\n\n  i {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    z-index: 10;\n  }\n}\n\n.loader.hidden {\n  opacity: 0;\n  pointer-events: none; /* Prevent interaction with hidden loader */\n}\n\n",".input-wrapper {\n  position: relative;\n}\n.input-wrapper i {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 10;\n}\n.loader.hidden {\n  opacity: 0;\n  pointer-events: none;\n  /* Prevent interaction with hidden loader */\n}\n/*# sourceMappingURL=bookings-form.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
